import {
  GET_PURCHASE_PROFILE,
  GET_PURCHASE_PROFILE_FAIL,
  GET_PURCHASE_PROFILE_SUCCESS,
  GET_PURCHASES,
  GET_PURCHASES_FAIL,
  GET_PURCHASES_SUCCESS,
  ADD_NEW_PURCHASE,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  UPDATE_PURCHASE,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  DELETE_PURCHASE,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
} from "./actionTypes"

export const getPurchases = ({  offset, page_size }) => ({
  type: GET_PURCHASES,
  payload: {  offset, page_size },
})

export const getPurchasesSuccess = purchases => ({
  type: GET_PURCHASES_SUCCESS,
  payload: purchases,
})

export const getPurchasesFail = error => ({
  type: GET_PURCHASES_FAIL,
  payload: error,
})

export const addNewPurchase = (user,history) => ({
  type: ADD_NEW_PURCHASE,
  payload: {user,history},
})

export const addPurchaseSuccess = user => ({
  type: ADD_PURCHASE_SUCCESS,
  payload: user,
})  

export const addPurchaseFail = error => ({
  type: ADD_PURCHASE_FAIL,
  payload: error,
})

export const updatePurchase = (purchase,history) => ({
  type: UPDATE_PURCHASE,
  payload: {purchase,history},
})

export const updatePurchaseSuccess = user => ({
  type: UPDATE_PURCHASE_SUCCESS,
  payload: user,
})

export const updatePurchaseFail = error => ({
  type: UPDATE_PURCHASE_FAIL,
  payload: error,
})

export const deletePurchase = user => ({
  type: DELETE_PURCHASE,
  payload: user,
})

export const deletePurchaseSuccess = user => ({
  type: DELETE_PURCHASE_SUCCESS,
  payload: user,
})

export const deletePurchaseFail = error => ({
  type: DELETE_PURCHASE_FAIL,
  payload: error,
})

export const getPurchaseProfile = () => ({
  type: GET_PURCHASE_PROFILE,
})

export const getPurchaseProfileSuccess = userProfile => ({
  type: GET_PURCHASE_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getPurchaseProfileFail = error => ({
  type: GET_PURCHASE_PROFILE_FAIL,
  payload: error,
})
